// extracted by mini-css-extract-plugin
var _1 = "MessageStatuses-modulestatus__hGSWK";
export { _1 as "status" }
